const mapModes = {
  graph: "Interactive Chart",
  heat: "National Overview",
  state: "State Comparison",
};

const nmhaMap_SourceId_Users = "nmhaUsers";
const nmhaMap_SourceId_UsersUnclustered = "nmhaUsersUnclustered";
const nmhaMap_SourceId_States = "usStates";

const graphModeFilters = [
  {
    filterName: "race",
    displayName: "Race",
    totalCount: 75594,
    breakdown: [
      {
        clusterProperty: "raceWhite",
        include: true,
        displayName: "White",
        count: 26725,
        color: "#0072F0",
      },
      {
        clusterProperty: "raceBlack",
        include: true,
        displayName: "Black or African American",
        count: 13392,
        color: "#FFA800",
      },
      {
        clusterProperty: "raceChinese",
        include: true,
        displayName: "Chinese",
        count: 20005,
        color: "#F10096",
      },
      {
        clusterProperty: "raceHispanic",
        include: true,
        displayName: "Hispanic",
        count: 8791,
        color: "#7CB342",
      },
      {
        clusterProperty: "raceVietnamese",
        include: true,
        displayName: "Vietnamese",
        count: 1964,
        color: "#F66D00",
      },
      {
        clusterProperty: "raceOtherAsian",
        include: true,
        displayName: "Other Asian",
        count: 1541,
        color: "#E1BEE7",
      },
      {
        clusterProperty: "raceAsianIndian",
        include: true,
        displayName: "Asian Indian",
        count: 1005,
        color: "#388E3C",
      },
      {
        clusterProperty: "raceFilipino",
        include: true,
        displayName: "Filipino",
        count: 892,
        color: "#C2185B",
      },
      {
        clusterProperty: "raceKorean",
        include: true,
        displayName: "Korean",
        count: 510,
        color: "#81D4FA",
      },
      {
        clusterProperty: "raceAmericanIndian",
        include: true,
        displayName: "American Indian or Alaskan",
        count: 296,
        color: "#FFD54F",
      },
      {
        clusterProperty: "raceJapanese",
        include: true,
        displayName: "Japanese",
        count: 196,
        color: "#F44336",
      },
      {
        clusterProperty: "racePacificIslander",
        include: true,
        displayName: "Other Pacific Islander",
        count: 206,
        color: "#D1D1D1",
      },
      {
        clusterProperty: "raceHawaiian",
        include: true,
        displayName: "Native Hawaiian",
        count: 34,
        color: "#737373",
      },
      {
        clusterProperty: "raceGuam",
        include: true,
        displayName: "Guamanian or Charmorro",
        count: 8,
        color: "#CF43F2",
      },
    ],
  },
  {
    filterName: "gender",
    displayName: "Gender",
    totalCount: 75585,
    breakdown: [
      {
        clusterProperty: "genderMale",
        include: true,
        displayName: "Male",
        count: 29136,
        color: "#0072F0",
      },
      {
        clusterProperty: "genderFemale",
        include: true,
        displayName: "Female",
        count: 45943,
        color: "#F10096",
      },
      {
        clusterProperty: "genderUnknown",
        include: true,
        displayName: "Unspecified",
        count: 506,
        color: "#FFA800",
      },
    ],
  },
  {
    filterName: "age",
    displayName: "Age",
    totalCount: 74441,
    breakdown: [
      {
        clusterProperty: "ageA",
        include: true,
        displayName: "Age 5-11",
        count: 3126,
        color: "#4285F4",
      },
      {
        clusterProperty: "ageB",
        include: true,
        displayName: "Age 12-17",
        count: 3272,
        color: "#EA4335",
      },
      {
        clusterProperty: "ageC",
        include: true,
        displayName: "Age 18-34",
        count: 23066,
        color: "#FBBC04",
      },
      {
        clusterProperty: "ageD",
        include: true,
        displayName: "Age 35-64",
        count: 33385,
        color: "#34A853",
      },
      {
        clusterProperty: "ageE",
        include: true,
        displayName: "Age 65+",
        count: 11595,
        color: "#FF6D01",
      },
    ],
  },
];

const heatModeFilters = [
  {
    filterName: "race",
    displayName: "Race",
    totalCount: 75594,
    showHeat: false,
    breakdown: [
      {
        clusterProperty: "raceWhite",
        include: true,
        displayName: "White",
        count: 26725,
        color: "#0072F0",
      },
      {
        clusterProperty: "raceBlack",
        include: true,
        displayName: "Black or African American",
        count: 13392,
        color: "#FFA800",
      },
      {
        clusterProperty: "raceChinese",
        include: true,
        displayName: "Chinese",
        count: 20005,
        color: "#F10096",
      },
      {
        clusterProperty: "raceHispanic",
        include: true,
        displayName: "Hispanic",
        count: 8791,
        color: "#7CB342",
      },
      {
        clusterProperty: "raceVietnamese",
        include: true,
        displayName: "Vietnamese",
        count: 1964,
        color: "#F66D00",
      },
      {
        clusterProperty: "raceOtherAsian",
        include: true,
        displayName: "Other Asian",
        count: 1541,
        color: "#E1BEE7",
      },
      {
        clusterProperty: "raceAsianIndian",
        include: true,
        displayName: "Asian Indian",
        count: 1005,
        color: "#388E3C",
      },
      {
        clusterProperty: "raceFilipino",
        include: true,
        displayName: "Filipino",
        count: 892,
        color: "#C2185B",
      },
      {
        clusterProperty: "raceKorean",
        include: true,
        displayName: "Korean",
        count: 510,
        color: "#81D4FA",
      },
      {
        clusterProperty: "raceAmericanIndian",
        include: true,
        displayName: "American Indian or Alaskan",
        count: 296,
        color: "#FFD54F",
      },
      {
        clusterProperty: "raceJapanese",
        include: true,
        displayName: "Japanese",
        count: 196,
        color: "#F44336",
      },
      {
        clusterProperty: "racePacificIslander",
        include: true,
        displayName: "Other Pacific Islander",
        count: 206,
        color: "#D1D1D1",
      },
      {
        clusterProperty: "raceHawaiian",
        include: true,
        displayName: "Native Hawaiian",
        count: 34,
        color: "#737373",
      },
      {
        clusterProperty: "raceGuam",
        include: true,
        displayName: "Guamanian or Charmorro",
        count: 8,
        color: "#CF43F2",
      },
    ],
  },
  {
    filterName: "gender",
    displayName: "Gender",
    totalCount: 75585,
    showHeat: false,
    breakdown: [
      {
        clusterProperty: "genderMale",
        include: true,
        displayName: "Male",
        count: 29136,
        color: "#0072F0",
      },
      {
        clusterProperty: "genderFemale",
        include: true,
        displayName: "Female",
        count: 45943,
        color: "#F10096",
      },
      {
        clusterProperty: "genderUnknown",
        include: true,
        displayName: "Unspecified",
        count: 506,
        color: "#FFA800",
      },
    ],
  },
  {
    filterName: "age",
    displayName: "Age",
    totalCount: 74441,
    showHeat: false,
    breakdown: [
      {
        clusterProperty: "ageA",
        include: true,
        displayName: "Age 5-11",
        count: 3126,
        color: "#4285F4",
      },
      {
        clusterProperty: "ageB",
        include: true,
        displayName: "Age 12-17",
        count: 3272,
        color: "#EA4335",
      },
      {
        clusterProperty: "ageC",
        include: true,
        displayName: "Age 18-34",
        count: 23066,
        color: "#FBBC04",
      },
      {
        clusterProperty: "ageD",
        include: true,
        displayName: "Age 35-64",
        count: 33385,
        color: "#34A853",
      },
      {
        clusterProperty: "ageE",
        include: true,
        displayName: "Age 65+",
        count: 11595,
        color: "#FF6D01",
      },
    ],
  },
];

const stateModeFilters = [
  {
    filterName: "vaccinations",
    displayName: "State Vaccinations By Race",
    clusterProperty: "All_Races",
    totalCount: 69016,
    breakdown: [
      {
        clusterProperty: "All_Races",
        include: true,
        displayName: "All Races",
        count: 69016,
      },
      {
        clusterProperty: "American_Indian_or_Alaskan",
        include: true,
        displayName: "American Indian or Alaskan",
        count: 304,
      },
      { clusterProperty: "Asian_Indian", include: true, displayName: "Asian Indian", count: 735 },
      {
        clusterProperty: "Black_or_African_American",
        include: true,
        displayName: "Black or African American",
        count: 13566,
      },
      { clusterProperty: "Chinese", include: true, displayName: "Chinese", count: 16976 },
      { clusterProperty: "Filipino", include: true, displayName: "Filipino", count: 664 },
      {
        clusterProperty: "Guamanian_or_Charmorro",
        include: true,
        displayName: "Guamanian or Charmorro",
        count: 7,
      },
      { clusterProperty: "Hispanic", include: true, displayName: "Hispanic", count: 8333 },
      { clusterProperty: "Japanese", include: true, displayName: "Japanese", count: 168 },
      { clusterProperty: "Korean", include: true, displayName: "Korean", count: 361 },
      {
        clusterProperty: "Native_Hawaiian",
        include: true,
        displayName: "Native Hawaiian",
        count: 24,
      },
      { clusterProperty: "Other_Asian", include: true, displayName: "Other Asian", count: 1238 },
      {
        clusterProperty: "Other_Pacific_Islander",
        include: true,
        displayName: "Other Pacific Islander",
        count: 185,
      },
      { clusterProperty: "Samoan", include: true, displayName: "Samoan", count: 33 },
      { clusterProperty: "Vietnamese", include: true, displayName: "Vietnamese", count: 1552 },
      { clusterProperty: "White", include: true, displayName: "White", count: 24870 },
    ],
  },
];

const theExports = {
  mapModes,
  graphModeFilters,
  heatModeFilters,
  stateModeFilters,
  nmhaMap_SourceId_Users,
  nmhaMap_SourceId_UsersUnclustered,
  nmhaMap_SourceId_States,
};

export default theExports;
